import format from 'date-fns/format';
import React from 'react';

import { Icon, Stack, Text } from '@eluve/components';

export interface DuplicateChartCardProps {
  name: string;
  startDate: string;
}

export const DuplicateChartCard: React.FC<DuplicateChartCardProps> = ({
  name,
  startDate,
}) => {
  return (
    <Stack gap={4} direction="horizontal">
      <div className="rounded-md bg-bg-tertiary p-2">
        <Icon size="2xl" name="ClipboardEdit" />
      </div>
      <Stack gap={0.5}>
        <Text weight="semibold">{name}</Text>
        <Stack
          className="text-xs font-medium text-text-tertiary"
          gap={2}
          direction="horizontal"
        >
          <p>{format(new Date(startDate), 'PP')}</p>
          <div className="size-1 rounded-full bg-text-tertiary"></div>
          <p>{format(new Date(startDate), 'p')}</p>
        </Stack>
      </Stack>
    </Stack>
  );
};
